import React from "react";
import { useLang } from "../../i18n/LanguageContext";
import { Heart, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Community = () => {
  const { t } = useLang();
  const points = t("community.points");
  return (
    <section className="relative py-32 lg:py-48 bg-[#081328]" data-testid="community-section">
      <div className="container-sat grid lg:grid-cols-2 gap-16 items-center">
        <div className="rounded-3xl overflow-hidden relative aspect-[4/5] border border-white/5">
          <img
            src="https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1400&q=85"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#081328] via-transparent to-transparent"></div>
          <div className="absolute bottom-6 left-6 right-6">
            <div className="overline mb-2">Herzbewegung</div>
            <div className="serif italic text-2xl text-white">„Jede Geste der Liebe ist Transformation."</div>
          </div>
        </div>

        <div>
          <div className="overline mb-6">{t("community.overline")}</div>
          <h2 className="headline-xl text-4xl md:text-5xl lg:text-6xl">{t("community.title")}</h2>
          <p className="text-white/70 text-lg mt-6 leading-relaxed">{t("community.subtitle")}</p>

          <div className="mt-10 grid grid-cols-2 gap-3">
            {points.map((p, i) => (
              <div key={i} className="glass rounded-xl px-5 py-4 flex items-center gap-3" data-testid={`community-point-${i}`}>
                <Heart size={14} className="text-[#D4AF37]" />
                <span className="text-sm text-white/80">{p}</span>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <Link to="/ecosystem/herzbewegung" className="btn-primary" data-testid="community-cta">
              {t("community.cta")} <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
